import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, TextField } from '@mui/material'
import {
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton
} from '@mui/x-data-grid'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import { t } from 'i18next'

// import { Logger, LoggerTypes } from '../../../utils'
import { variantTypes } from '../../../constants'

export const DataGridSearchToolbar = ({ searchValue, onSearch, onClearSearch }) => {
  // Logger.trace(LoggerTypes.CONTAINER, 'DataGridSearchToolbar.render()', { searchValue })
  return (
    <GridToolbarContainer className="quickSearchToolbar">
      <div className="quickSearchHeader quickSearchButtons">
        <GridToolbarDensitySelector />
        <GridToolbarFilterButton />
        <GridToolbarExport delimiter={','} filename={'export-table'} />
      </div>
      <div className="quickSearchHeader quickSearchTextfield">
        <TextField
          variant={variantTypes.STANDARD}
          value={searchValue}
          onChange={onSearch}
          placeholder={t('common.placeholders.search')}
          className="textField"
          InputProps={{
            startAdornment: <SearchIcon fontSize="small" />,
            endAdornment: (
              <IconButton
                title="Clear"
                aria-label="Clear"
                size="small"
                style={{ visibility: searchValue ? 'visible' : 'hidden' }}
                onClick={onClearSearch}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            )
          }}
        />
      </div>
    </GridToolbarContainer>
  )
}

DataGridSearchToolbar.displayName = 'DataGridSearchToolbar'

DataGridSearchToolbar.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onClearSearch: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired
}

DataGridSearchToolbar.defaultProps = {
  searchValue: '',
  onClearSearch: () => {},
  onSearch: () => {}
}
